import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";

interface Props {
  customError?: string;
  defaultDate: string;
  label: string;
  minDate?: string;
  maxDate?: string;
  onChange: (value: unknown) => void;
  onError: (hasError: boolean) => void;
}

export default function DateSelect({
  customError,
  defaultDate,
  label,
  minDate,
  maxDate,
  onChange,
  onError,
}: Props) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    onError(Boolean(errorMessage));
  }, [errorMessage]);

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DatePicker
        value={defaultDate}
        minDate={minDate}
        maxDate={maxDate}
        onChange={(newValue) =>
          onChange(DateTime.fromISO(newValue).toFormat("yyyy-LL-dd"))
        }
        onError={(reason) => setErrorMessage(reason)}
        label={label}
        format="MM/dd/yyyy"
        views={["month", "day"]}
        slotProps={{
          textField: {
            error: Boolean(errorMessage),
            helperText: errorMessage ? customError || errorMessage : "",
          },
        }}
      />
    </LocalizationProvider>
  );
}
